import { EntityType, EntityWithRoleBinding } from "./types";
import { RoleBindingView } from "../types";

export const getEntities = (roleBindings: RoleBindingView[]) => {
  const {
    userRoleBindingsCount,
    apiKeyRoleBindingsCount,
    userGroupRoleBindingsCount,
    stackRoleBindingsCount,
  } = roleBindings.reduce(
    (acc, roleBinding) => {
      if (roleBinding.__typename === "UserRoleBinding") {
        acc.userRoleBindingsCount += 1;
      } else if (roleBinding.__typename === "ApiKeyRoleBinding") {
        acc.apiKeyRoleBindingsCount += 1;
      } else if (roleBinding.__typename === "UserGroupRoleBinding") {
        acc.userGroupRoleBindingsCount += 1;
      } else if (roleBinding.__typename === "StackRoleBinding") {
        acc.stackRoleBindingsCount += 1;
      }
      return acc;
    },
    {
      userRoleBindingsCount: 0,
      apiKeyRoleBindingsCount: 0,
      userGroupRoleBindingsCount: 0,
      stackRoleBindingsCount: 0,
    }
  );

  return (
    roleBindings?.reduce<EntityWithRoleBinding[]>((acc, roleBinding) => {
      const sharedValues = {
        roleBindingId: roleBinding.id,
        space: roleBinding.space,
      };

      if (roleBinding.__typename === "UserRoleBinding") {
        const user = roleBinding.user;

        return [
          ...acc,
          {
            type: EntityType.User,
            id: user.id,
            name: user.username,
            isLastRole: userRoleBindingsCount === 1,
            ...sharedValues,
          },
        ];
      }

      if (roleBinding.__typename === "ApiKeyRoleBinding") {
        const apiKey = roleBinding.apiKey;

        return [
          ...acc,
          {
            type: EntityType.ApiKey,
            id: apiKey.id,
            name: apiKey.name,
            isLastRole: apiKeyRoleBindingsCount === 1,
            ...sharedValues,
          },
        ];
      }

      if (roleBinding.__typename === "UserGroupRoleBinding") {
        const userGroup = roleBinding.userGroup;

        return [
          ...acc,
          {
            type: EntityType.UserGroup,
            id: userGroup.id,
            name: userGroup.groupName,
            isLastRole: userGroupRoleBindingsCount === 1,
            ...sharedValues,
          },
        ];
      }

      if (roleBinding.__typename === "StackRoleBinding") {
        return [
          ...acc,
          {
            type: EntityType.Stack,
            id: roleBinding.stackID,
            name: roleBinding.stackName,
            isLastRole: stackRoleBindingsCount === 1,
            ...sharedValues,
          },
        ];
      }

      return acc;
    }, []) || []
  );
};
